// Construit un lien tel: valide à partir d'un numéro local et de son indicatif pays
// (ex: number="02 33 75 78 58", dialingCode="33" -> "tel:+33233757858").
// Si l'indicatif est absent, on se contente de nettoyer le numéro tel quel.
export const toTelHref = (number: string, dialingCode?: string): string => {
  const digitsOnly = number.replace(/\D/g, '');
  if (!dialingCode) return `tel:${digitsOnly}`;
  const localNumber = digitsOnly.replace(/^0+/, '');
  return `tel:+${dialingCode}${localNumber}`;
};
